<template>
  <div id="etiquette-dpe" v-if="post.dpe_valeur_conso || post.dpe_etiquette_conso || post.dpe_valeur_ges || post.dpe_etiquette_ges">
<!--    <el-row>-->
<!--      <el-col :span="6" style="font-size: 12px;margin-left: 8px;"><strong>Conso. énergétique</strong></el-col>-->
<!--      <el-col :span="4" style="font-size: 12px;margin-left: 45px;"><strong>Emissions GES</strong></el-col>-->
<!--    </el-row>-->
    <el-row>
      <el-row>
        <el-col :lg="15"><p style="font-weight: bold">Classe énérgie :</p></el-col>
      </el-row>
      <el-row>
        <el-col :lg="1">&nbsp;</el-col>
        <el-col :lg="4" style="font-weight: 400; font-size: 13px; margin-top: 8px">
                    <div id="valeur-dpe" :class="'valeur-pdf-'+ lowerStr(post.dpe_etiquette_conso)">
                      <div class="valeur-block">
                        <strong>{{ post.dpe_valeur_conso }}</strong><br />
                        <span style="font-size: 8px;">kWh/m².an</span>
                      </div>
                    </div>
        </el-col>
        <el-col :lg="8"><img :src="require('@/assets/DPE_' + post.dpe_etiquette_conso + '.png')" :alt="post.dpe_etiquette_conso"></el-col>
      </el-row>
      <el-row style="margin-top: 25px;">
        <el-col :lg="15"><p style="font-weight: bold">GES :</p></el-col>
      </el-row>
      <el-row style="margin-bottom: 25px;">
        <el-col :lg="1">&nbsp;</el-col>
        <el-col :lg="4" style="font-weight: 400; font-size: 13px; margin-top: 8px">
                    <div id="valeur-ges" :class="'valeur-pdf-'+ lowerStr(post.dpe_etiquette_ges)">
                      <div class="valeur-block">
                        <strong>{{ post.dpe_valeur_ges }}</strong><br />
                        <span style="font-size: 8px;">kgCO2/m².an</span>
                      </div>
                    </div>
        </el-col>
        <el-col :lg="8"><img :src="require('@/assets/GAS_' + post.dpe_etiquette_ges + '.png')" :alt="post.dpe_etiquette_ges"></el-col>
      </el-row>
    </el-row>
<!--      <el-col :span="6">-->
<!--        <div id="dpe">-->
<!--          <div id="valeur-dpe" :class="'valeur-pdf-'+ lowerStr(post.dpe_etiquette_conso)">-->
<!--            <div class="valeur-block">-->
<!--              {{ post.dpe_valeur_conso }}<br />-->
<!--              <span style="font-size: 8px;">kWh/m².an</span>-->
<!--            </div>-->
<!--            <div class="valeur-block">-->
<!--              {{ post.dpe_valeur_ges }}<br />-->
<!--              <span style="font-size: 8px;">kgCO2/m².an</span>-->
<!--            </div>-->
<!--          </div>-->
<!--          <img src="@/assets/vignette-dpe.jpg" width="130" alt="dpe" />-->
<!--        </div>-->
<!--      </el-col>-->
<!--      <el-col :span="4">-->
<!--        <div id="ges">-->
<!--          <div id="valeur-ges" :class="'valeur-pdf-'+ lowerStr(post.dpe_etiquette_ges)">-->
<!--            <div class="valeur-block">-->
<!--              {{ post.dpe_valeur_ges }}<br />-->
<!--              <span style="font-size: 8px;">kgCO2/m².an</span>-->
<!--            </div>-->
<!--          </div>-->
<!--          <img src="@/assets/vignette-ges.jpg" width="130" alt="ges" />-->
<!--        </div>-->
<!--      </el-col>-->
  </div>
</template>

<script>
export default {
  name: 'EtiquetteDPEGESPdfNew',
  props: ['post'],
  data () {
    return {}
  },
  computed: {},
  methods: {
    lowerStr (str) {
      if (str != null) {
        return str.toLowerCase()
      }
    }
  }
}
</script>

<style type="text/css">
#etiquette-dpe {
  width:500px;
  height:145px;
  position:relative;
}

#etiquette-dpe #dpe, #etiquette-dpe #ges {
  width:236px;
  height:145px;
  position:relative;
  float:left;
}

#etiquette-dpe #dpe {
  margin-right:15px;
}

#etiquette-dpe img {
  position:relative;
  z-index:998;
}

#etiquette-dpe #dpe #valeur-dpe, #etiquette-dpe #ges #valeur-ges {
  height:25px;
  position:absolute;
  right:120px;
  z-index:999;
  font:bold 12px Arial, Helvetica, sans-serif;
}

#etiquette-dpe .valeur-block {
  float: left;
  text-align: center;
  border: 1px solid;
  padding-left: 2px;
  padding-right: 2px;
}

#etiquette-dpe .valeur-pdf-a {
  top:5px;
}
#etiquette-dpe .valeur-pdf-b {
  top:20px;
}
#etiquette-dpe .valeur-pdf-c {
  top:35px;
}
#etiquette-dpe .valeur-pdf-d {
  top:50px;
}
#etiquette-dpe .valeur-pdf-e {
  top:65px;
}
#etiquette-dpe .valeur-pdf-f {
  top:80px;
}
#etiquette-dpe .valeur-pdf-g {
  top:95px;
}
</style>
